import { render } from "./ReturnProductDetail.vue?vue&type=template&id=6fbe84d6&scoped=true&ts=true"
import script from "./ReturnProductDetail.vue?vue&type=script&lang=ts"
export * from "./ReturnProductDetail.vue?vue&type=script&lang=ts"

import "./ReturnProductDetail.vue?vue&type=style&index=0&id=6fbe84d6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbe84d6"]])

export default __exports__